import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class sellersListCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $state,
        $uibModal,
        logger,
        $translate,
        KISS_SELLER,
        SellersFilter,
        KissSellerSvc,
        PrincipalSvc,
        AuthSvc,
        PrincipalsDA
    ) {
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.$translate = $translate;
        this.KISS_SELLER = KISS_SELLER;
        this.SellersFilter = SellersFilter;
        this.KissSellerSvc = KissSellerSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.PrincipalsDA = PrincipalsDA;
    }

    $onInit() {
        // Mise à jour du status pour menu et boutons
        this.princStatus = this.PrincipalSvc.getPrincStatus();

        // Recherche
        this.statusList = this.KISS_SELLER.seller.status;
        this.langs = this.PrincipalSvc.getLangs();
        this.searchOpen = true;
        this.searchData =
            this.PrincipalSvc.getSellerListFilter() && this.keepSearchData
                ? this.PrincipalSvc.getSellerListFilter()
                : new this.SellersFilter();

        this.exportReminderTaskId = null;
        this.displayexportReminderProgress = false;
        this.exportReminderType = null;

        this.csvEditiqueTaskId = null;
        this.displayCsvEditiqueProgress = false;
        // Envoi des notifications
        this.displayValidateNotifsProgress = false;
        this.csvValidateNotifsTaskId = null;

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.invitedentity.edit({id: row.entity.id})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        var relationsTemplate =
            '<div ng-show="row.entity.relations > 0" class="ui-grid-cursor-pointer text-center" ng-click="grid.appScope.$ctrl.viewRelations(row)"><i class="fa fa-search"></i></div>';
        var invitationTemplate =
            '<div class="ui-grid-cursor-pointer text-center" ng-click="grid.appScope.$ctrl.viewInvitation(row)"><i class="fa fa-search"></i></div>';
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'name',
                    displayName: 'principal.sellers.col_name.name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLegalId()',
                    displayName: 'principal.sellers.col_name.id',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getCountryLabel()',
                    displayName: 'kiss_seller.list.country',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLangLabel()',
                    displayName: 'kiss_seller.list.lang',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'kiss_seller.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
                {
                    name: 'invitation',
                    displayName: 'kiss_seller.list.invitation',
                    headerCellFilter: 'translate',
                    cellTemplate: invitationTemplate,
                    cellClass: 'pointer',
                    width: 80,
                    enableColumnMenu: false,
                    enableSorting: false,
                },
                {
                    name: 'relations',
                    displayName: 'kiss_seller.list.relations',
                    headerCellFilter: 'translate',
                    cellTemplate: relationsTemplate,
                    cellClass: 'pointer',
                    width: 80,
                    enableColumnMenu: false,
                    enableSorting: false,
                },
            ],
            useExternalPagination: true,
            useExternalSorting: true,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.search();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.searchData.setPageSize(size);
                    this.searchData.setPage(page - 1);
                    this.search();
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };

        this.preparedSearchFilter = {};
        this.headers = [];

        if (!this.searchData.preparBeforeSearch) {
            this.searchData = new this.SellersFilter();
            this.PrincipalSvc.initSellerFilterSessionStorage();
        }

        //initialiser le filtre de recherche pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();

        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
        this.search();
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_SELLER.seller.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    openImportSellers() {
        this.$uibModal
            .open({
                component: 'modalImport',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    type: () => {
                        return 'sellers';
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                hasUpdate => this.closeModal(hasUpdate),
                () => {}
            );
    }

    openImportRelations() {
        this.$uibModal
            .open({
                component: 'modalImport',
                resolve: {
                    principal: () => {
                        return this.principal;
                    },
                    type: () => {
                        return 'relations';
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                hasUpdate => this.closeModal(hasUpdate),
                function () {}
            );
    }

    execValidateNotifs() {
        this.PrincipalSvc.sendNotifications(this.principal.detail.id).then(
            taskId => {
                this.csvValidateNotifsTaskId = taskId;
                this.displayValidateNotifsProgress = true;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                } else {
                    // TODO voir ce qu'on fait ici
                    this.logger.error('error.notifications');
                }
            }
        );
    }

    openExportReminders() {
        this.$uibModal
            .open({
                component: 'modalExportReminder',
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                type => this.execExportReminder(type),
                () => {}
            );
    }

    closeModal(hasUpdate) {
        if (hasUpdate) {
            this.PrincipalSvc.refreshPrincStatus(this.PrincipalSvc.getPrincipalId()).then(princStatus => {
                this.princStatus = princStatus;
            });
        }
    }

    showReminderExport() {
        return this.PrincipalSvc.getPrincStatus().nbNotifSentNotifiedStatus > 0;
    }

    execCsvEditique() {
        this.PrincipalsDA.execCsvEditique(this.principal.detail.id).then(
            taskId => {
                this.csvEditiqueTaskId = taskId;
                this.displayCsvEditiqueProgress = true;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                } else {
                    this.logger.error('error.generic');
                }
            }
        );
    }

    searchSellers(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchSellersByNameOrId(this.principal.detail.id, value).then(sellers => {
                return _.uniqBy(sellers, 'legalEntityId');
            });
        }
    }

    search() {
        // Dans le cas où l'on recharge une page de données différente de la 1ere sans passer par l'IHM
        // de pagination de la grille alors la grille se recharge en indiquant que l'on affiche la page 1
        // alors qu'il s'agit en fait de la page n.
        // La solution pérenne est plutôt de passer par un save/restoreState afin de récupérer la pagination
        // ainsi que les indicateurs de tri sur les colonnes
        if (this.gridOptions.paginationCurrentPage === undefined && this.searchData.pageCriteria.page > 0) {
            this.gridOptions.totalItems = 99999;
            this.gridOptions.paginationCurrentPage = this.searchData.pageCriteria.page + 1;
            this.search();
        } else {
            this.kissSellerPromise = this.PrincipalSvc.searchSellers(this.principal.detail.id, this.searchData);
            this.kissSellerPromise.then(
                pageSellers => {
                    this.gridOptions.data = pageSellers.sellers;
                    this.gridOptions.totalItems = pageSellers.totalItems;
                    //enregistrer le filtre de recherche formaté pour l'export
                    this.preparedSearchFilter = this.searchData.preparBeforeSearch();
                },
                (/*error*/) => {
                    this.logger.error('error.search');
                }
            );
        }
    }

    clearForm() {
        // Reset data
        this.searchData = new this.SellersFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    viewRelations(row) {
        var principalInfo = {
            corporateName: null,
            eid: null,
        };
        if (this.principal && this.principal.detail) {
            principalInfo.corporateName = this.principal.detail.corporateName;
            principalInfo.eid = this.principal.detail.eid;
        }
        this.$state.go('app.principal.sellerrelations', { id: row.entity.id, principalInfo: principalInfo });
    }

    viewInvitation(row) {
        var entity = {
            id: row.entity.id,
            name: row.entity.name,
            status: row.entity.status,
            identifier: row.entity.getLegalId(),
        };
        this.$state.go('app.principal.consult.detailsinvitation', {
            entity: entity,
            invitationId: row.entity.invitation,
        });
    }

    onCsvEditiqueTaskEnd(result) {
        // Adaptation **TEMPORAIRE** du résultat (le format change entre Kiss 3.1 et Kiss 3.2)
        let res = result;
        if (result.result) {
            // Format Kiss 3.2 : { success=boolean, result=résultat }
            res = result.result;
        }

        this.displayCsvEditiqueProgress = false;
        if (result) {
            this.$uibModal
                .open({
                    component: 'modalExportInvitation',
                    resolve: {
                        principal: () => {
                            return this.principal;
                        },
                        reportData: () => {
                            return this.PrincipalSvc.getExportInvitationsLinks(res);
                        },
                    },
                    backdrop: 'static',
                    keyboard: false,
                })
                .result.then(
                    hasUpdate => this.closeModal(hasUpdate),
                    () => {}
                );
        } else {
            this.logger.error('error.notifications');
        }
    }

    onValidateNotifsTaskEnd(result) {
        // Adaptation **TEMPORAIRE** du résultat (le format change entre Kiss 3.1 et Kiss 3.2)
        let res = result;
        if (result.result) {
            // Format Kiss 3.2 : { success=boolean, result=résultat }
            res = result.result;
        }

        this.displayValidateNotifsProgress = false;
        if (result) {
            this.$uibModal
                .open({
                    component: 'modalNotification',
                    resolve: {
                        principal: () => {
                            return this.principal;
                        },
                        reportData: () => {
                            return this.PrincipalSvc.getReportWithLink(res);
                        },
                    },
                    backdrop: 'static',
                    keyboard: false,
                })
                .result.then(
                    hasUpdate => this.closeModal(hasUpdate),
                    () => {}
                );
        } else {
            this.logger.error('error.generic');
        }
    }

    execExportReminder(type) {
        this.exportReminderType = type;
        this.PrincipalsDA.execExportReminder(this.principal.detail.id, type).then(
            taskId => {
                this.exportReminderTaskId = taskId;
                this.displayexportReminderProgress = true;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                } else {
                    this.logger.error('error.notifications');
                }
            }
        );
    }

    onExportReminderTaskEnd(result) {
        // Adaptation **TEMPORAIRE** du résultat (le format change entre Kiss 3.1 et Kiss 3.2)
        let fileId = result;
        if (result.result) {
            // Format Kiss 3.2 : { success=boolean, result=résultat }
            fileId = result.result;
        }

        this.displayexportReminderProgress = false;
        if (fileId != null) {
            //telecharger le fichier resultat
            this.PrincipalsDA.getExportReminder(this.exportReminderType, this.principal.detail.id, fileId).then(
                () => {
                    this.PrincipalSvc.refreshPrincStatus(this.PrincipalSvc.getPrincipalId()).then(princStatus => {
                        this.princStatus = princStatus;
                    });
                },
                (/*error*/) => {
                    this.logger.error('error.generic');
                }
            );
        } else {
            this.logger.error('error.generic');
        }
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    backList() {
        this.$state.go('do', { tabName: 'principal' });
    }
}

angular.module('app.principal').component('sellersList', {
    templateUrl: require('./sellers-list.html'),
    controller: sellersListCtrl,
    bindings: {
        principal: '<',
        keepSearchData: '<',
    },
});
